import { Assignment } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import ReactTable from "react-table";
import { travelApi } from "functions/apis";
import { formatCurrency } from "functions/Helper";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import EditIcon from "@material-ui/icons/Edit";
import PropTypes from "prop-types";
import { token } from "functions/Helper";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const useStyles = makeStyles(styles);

const AgentMerchantProductPricingList = props => {
  const classes = useStyles();

  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);

  const { id } = props;

  const [filter, setFilter] = useState({
    searchString: "",
    agentID: id,
    currentActive: false,
    travelDate: null,
    age: null,
    sort: 0
  });

  const agentMerchantProductPricingListSignal = React.useRef(
    new AbortController()
  );

  useEffect(() => {
    return () => {
      agentMerchantProductPricingListSignal.current.abort();
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    travelApi
      .get("AgentPricings", {
        params: {
          filter,
          pagination
        },
        signal: agentMerchantProductPricingListSignal.current.signal
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token["travelagent.pricings.read"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={
                        "/admin/Agent/MerchantProductPricing/Detail/" +
                        record.id
                      }
                    >
                      <Button color="info" className="like">
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                  )}
                  {(token["travelagent.pricings.write"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={
                        "/admin/Agent/MerchantProductPricing/Edit/" + record.id
                      }
                    >
                      <Button color="danger" className="remove">
                        <EditIcon /> EDIT
                      </Button>
                    </Link>
                  )}
                  {(token["travelagent.pricings.write"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={
                        "/admin/Agent/MerchantProductPricing/Delete/" +
                        record.id
                      }
                    >
                      <Button color="danger" className="remove">
                        <DeleteIcon /> DELETE
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
        setLoading(false);
      });
  }, [filter, pagination]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>MERCHANT PRODUCT PRICING</h4>
          </CardHeader>
          <CardBody>
            {(token["travelagent.pricings.write"] === "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/Agent/CreateMerchantProductPricing/" + id}>
                <Button color="rose" type="button" value="Create">
                  Create
                </Button>
              </Link>
            )}

            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value:
                      filter.searchString === null ? "" : filter.searchString
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridItem>
              <ReactTable
                manual
                pages={pages}
                page={pagination.pageIndex - 1}
                pageSize={pagination.pageSize}
                onPageChange={page =>
                  setPagination({
                    pageIndex: page + 1,
                    pageSize: pagination.pageSize
                  })
                }
                onPageSizeChange={(pageSize, page) => {
                  setPagination({ pageSize: pageSize, pageIndex: page + 1 });
                }}
                loading={loading}
                data={data}
                filterable={false}
                columns={[
                  {
                    id: "productName",
                    Header: "Product Name",
                    accessor: d => d.product.name
                  },
                  {
                    id: "agentCode",
                    Header: "Agent Code",
                    accessor: d => d.agent.code
                  },
                  {
                    id: "ageVariant",
                    Header: "Age Variant",
                    accessor: d =>
                      d.variant && d.variant != "" ? d.variant.name : "-"
                  },
                  {
                    id: "price",
                    Header: "Price",
                    accessor: d =>
                      formatCurrency(
                        !d.agent.billingCurrency
                          ? "XXX"
                          : d.agent.billingCurrency.code,
                        d.price
                      )
                  },

                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </GridItem>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default AgentMerchantProductPricingList;

AgentMerchantProductPricingList.propTypes = {
  id: PropTypes.string
};
